import React, { useState } from "react";
import Iframe from "react-iframe";
import { InlineMath } from "react-katex";
const Chtambahan = ({ukuranH, ukuranP}) => {
	
	const [show0, setShow0] = useState(true);
	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);


	const [styleno1, setStyleno1] = useState({ width: "40px", height: "40px" });
	const [styleno2, setStyleno2] = useState({ width: "40px", height: "40px" });
	const chlain1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "0" ||jwb.toUpperCase() === "1"||jwb.toUpperCase() === "2"||jwb.toUpperCase() === "3") {
			setStyleno1({
				width: "60px",
				height: "40px",
				border: "6px solid #1aff66",
			});
		
		} else if (jwb === "") {
			setStyleno1({
				width: "60px",
				height: "40px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno1({
				width: "60px",
				height: "40px",
				border: "6px solid red",
			});
		}
	};
	const chlain2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "0" ||jwb.toUpperCase() === "1"||jwb.toUpperCase() === "2") {
			setStyleno2({
				width: "60px",
				height: "40px",
				border: "6px solid #1aff66",
			});
		
		} else if (jwb === "") {
			setStyleno2({
				width: "60px",
				height: "40px",
				border: "6px solid yellow",
			});
		} else {
			setStyleno2({
				width: "60px",
				height: "40px",
				border: "6px solid red",
			});
		}
	};

	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "solid",
				borderColor: "#2d8659",
				borderRadius: "25px",
				boxShadow: "5px 5px #888887",
			}}
			className="container mt-2 mb-2"
		>
			<div className="text-center" style={{fontSize:`${ukuranP}px`}}>Perhatikan Pertidaksamaan berikut</div>
			<div className="text-center" style={{fontSize:`${ukuranP}px`}}>
				<InlineMath math="x + 2y ≤ 6" />
			</div>
			<div style={{ marginLeft: "15px" }}>
				<p
					style={{
						padding: "15px 20px 60px 15px",
						textAlign: "justify",
						textIndent: "2rem",
						fontSize:`${ukuranH}px`
					}}
				>
					<strong>A. Titik Penyelesaian</strong>
				</p>
				<div style={{fontSize:`${ukuranP}px`}} className="row">
					<div className="text-center ">
						<p>Apakah (x,y) = (0, 0) merupakan penyelesaian?</p>
					</div>
				</div>
				{show0?
			<>
					<div className="d-flex justify-content-center">
					<button
						className="btn btn-success btn-sm mb-2"
						onClick={() => setShow1(true)&&setShow0(false)}
					>
						Lanjut
					</button>
				</div>
			</> 
			:null}
				{show1 ? (
					<>
						<div
							style={{
								border: "2px solid green",
								borderRadius: "20px",
								width: "70%",
								margin: "auto",
								fontSize:`${ukuranP}px`
							}}
							className="text-center mt-2 mb-2"
						>
							<p className="">
								Karena ketika kita memasukkan (0,0), kedalam
								<InlineMath math="\space x + 2y ≤ 6 " /> maka :
							</p>
							<p>
								<InlineMath math="\iff 0 + 2(0) ≤ 6 " />
							</p>
							<p>
								<InlineMath math="\iff 0 + 0 ≤ 6 " />
							</p>
							<p>
								<InlineMath math="\iff 0 ≤ 6 " />
							</p>
							<p className="alert alert-success"> Ya benar, (x,y) = (0,0) merupakan penyelesaian</p>
						</div>

						<div style={{fontSize:`${ukuranP}px`}} className="row">
							<div className="text-center">
								<p>Apakah (x,y) = (10, -3) merupakan penyelesaian?</p>
							</div>
						
						</div>
						<div className="d-flex justify-content-center">
							<button
								className="btn btn-success btn-sm mx-auto"
								onClick={() => setShow2(true)}
							>
								Lanjut
							</button>
						</div>
						{show2 ? (
							<>
								<div
									style={{
										border: "2px solid green",
										borderRadius: "20px",
										width: "70%",
										margin: "auto",
										fontSize:`${ukuranP}px`
									}}
									className="text-center mt-2 mb-2"
								>
									<p className="">
										Karena ketika kita memasukkan (10,-3), kedalam
										<InlineMath math="\space x + 2y ≤ 6 " /> maka :
									</p>
									<p>
										<InlineMath math="\iff 10 + 2(-3) ≤ 6 " />
									</p>
									<p>
										<InlineMath math="\iff 10 + (-6) ≤ 6 " />
									</p>
									<p>
										<InlineMath math="\iff 4 ≤ 6 " />
									</p>
									<p className="alert alert-success"> Ya benar, (x,y) = (10,-3) merupakan penyelesaian</p>
								</div>

								<div style={{fontSize:`${ukuranP}px`}} className="row">
									<div className="text-center">
										<p>Apakah (x,y) = (3, 1) merupakan penyelesaian?</p>
									</div>
								</div>
								<div className="d-flex justify-content-center">
									<button
										className="btn btn-success btn-sm mx-auto"
										onClick={() => setShow3(true)}
									>
										Lanjut
									</button>
								</div>
								{show3 ? (
									<>
										<div
											style={{
												border: "2px solid green",
												borderRadius: "20px",
												width: "70%",
												margin: "auto",
												fontSize:`${ukuranP}px`
											}}
											className="text-center mt-2 mb-2"
										>
											<p className="">
												Karena ketika kita memasukkan (3,1), kedalam
												<InlineMath math="\space x + 2y ≤ 6 " /> maka :
											</p>
											<p>
												<InlineMath math="\iff 3 + 2(1) ≤ 6 " />
											</p>
											<p>
												<InlineMath math="\iff 3 + 2 ≤ 6 " />
											</p>
											<p>
												<InlineMath math="\iff 5 ≤ 6 " />
											</p>
											<p className="alert alert-success"> Ya benar, (x,y) = (3,1) merupakan penyelesaian</p>
										</div>

										<div style={{fontSize:`${ukuranP}px`}} className="row">
											<div className="text-center">
												<p>Apakah (x,y) = (3, 5) merupakan penyelesaian?</p>
											</div>
										</div>
										<div className="d-flex justify-content-center">
											<button
												className="btn btn-success btn-sm mx-auto"
												onClick={() => setShow4(true)}
											>
												Lanjut
											</button>
										</div>
										{show4 ? (
											<>
												<div
													style={{
														border: "2px solid green",
														borderRadius: "20px",
														width: "70%",
														margin: "auto",
														fontSize:`${ukuranP}px`
													}}
													className="text-center mt-2 mb-2"
												>
													<p className="">
														Karena ketika kita memasukkan (3,5), kedalam
														<InlineMath math="\space x + 2y ≤ 6 " /> maka :
													</p>
													<p>
														<InlineMath math="\iff 3 + 2(5) ≤ 6 " />
													</p>
													<p>
														<InlineMath math="\iff 3 + 10 ≤ 6 " />
													</p>
													<p>
														<InlineMath math="\iff 13 ≤ 6 " />
													</p>
													<p className="alert alert-danger"> Tidak, karena 13 <InlineMath math=" ≥ " /> 6, jadi (x,y) = (3,5) bukan merupakan penyelesaian</p>
												</div>

												<div style={{fontSize:`${ukuranP}px`}} className="row">
													<div className="text-center">
														<p>Apakah (x,y) = (4, 3) merupakan penyelesaian?</p>
													</div>
												</div>
												<div className="d-flex justify-content-center">
													<button
														className="btn btn-success btn-sm mx-auto"
														onClick={() => setShow5(true)}
													>
														Lanjut
													</button>
												</div>
												{show5 ? (
													<>
														<div
															style={{
																border: "2px solid green",
																borderRadius: "20px",
																width: "70%",
																margin: "auto",
																fontSize:`${ukuranP}px`
															}}
															className="text-center mt-2 mb-2"
														>
															<p className="">
																Karena ketika kita memasukkan (4,3), kedalam
																<InlineMath math="\space x + 2y ≤ 6 " /> maka :
															</p>
															<p>
																<InlineMath math="\iff 4 + 2(3) ≤ 6 " />
															</p>
															<p>
																<InlineMath math="\iff 4 + 6 ≤ 6 " />
															</p>
															<p>
																<InlineMath math="\iff 10 ≤ 6 " />
															</p>
															<p className="alert alert-danger"> Tidak, karena 10 <InlineMath math=" ≥ " /> 6, jadi (x,y) = (4,3) bukan merupakan penyelesaian</p>
														</div>
														<div style={{fontSize:`${ukuranP}px`}} className="row mb-2">
															<div className="text-center">
																Berapa banyaknya penyelesaian dari
																pertidaksamaan tersebut?
															</div>
														</div>
														<div className="d-flex justify-content-center">
															<button
																className="btn btn-success btn-sm mx-auto"
																onClick={() => setShow6(true)}
															>
																Penjelasan
															</button>
														</div>
														{show6 ? (
															<>
																<div
																	style={{
																		border: "2px solid green",
																		borderRadius: "20px",
																		width: "70%",
																		margin: "auto",
																	}}
																	className="text-center mt-2 mb-2"
																>
																	<p style={{fontSize:`${ukuranP}px`}} >Jawabannya adalah "Banyak". 
																		Karena tidak hanya terdapat satu saja,
																		melainkan masih banyak terdapat titik
																		koordinat yang memenuhi pertidaksamaan di
																		atas{" "}
																	</p>
																</div>
																<div style={{fontSize:`${ukuranP}px`}} className="d-flex justify-content-center">																
																		Berikan contoh lainnya dimana <InlineMath math="\space x < 4 \space" /> dan <InlineMath math="\space y < 3 " />   
																</div>
																<div style={{fontSize:`${ukuranP}px`}} className="d-flex justify-content-center">
																																
																<h6>
																			x <input type="text" onChange={chlain1} style={styleno1} />
																		</h6> 
																	<p>&nbsp;dan&nbsp;</p> 
																		<h6>
																			y <input type="text" onChange={chlain2} style={styleno2} />
																		</h6>
															
																</div>

																<div
																	style={{
																		padding: "15px 20px 60px 15px",
																		textAlign: "justify",
																		textIndent: "2rem",
																	}}
																>
																	<p>
																		<strong style={{fontSize:`${ukuranH}px`}}>B. Daerah Penyelesain </strong>
																	</p>
																	<p style={{fontSize:`${ukuranP}px`}}>
																		Suatu pertidaksamaan linier dua variabel
																		(PLDV) memiliki banyak penyelesaian. Secara
																		Geometris penyelesaian dari suatu PLDV
																		berupa suatu daerah pada sumbu koordinat.
																		Perhatikan Gambar dibawah ini.
																	</p>
																</div>
																<div className="d-flex justify-content-center mb-2">
																	<Iframe
																		scrolling="no"
																		title="Chbaru1"
																		src="https://www.geogebra.org/material/iframe/id/m9cfurvq/width/500/height/400/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
																		width="400px"
																		height="300px"
																		allowFullScreen
																	/>
																</div>
																<div className="text-center">
																	<i>Gambar1</i>
																</div>
																<div
																	style={{
																		marginLeft: "25px",
																		marginRight: "25px",
																		textAlign: "justify",
																		textIndent: "2rem",
																		
																	}}
																>
																	<p style={{fontSize:`${ukuranP}px`}}>
																		{" "}
																		Pada Gambar 1 dapat dilihat garis{" "}
																		<InlineMath math=" x+2y=6 " /> membagi dua
																		daerah sumbu koordinat menjadi dua bagian,
																		bagian kiri (memuat titik (0,0)), dan bagian
																		kanan. Berdasarkan jawaban
																		pertanyaan-pertanyaan pada bagian A.
																	</p>
																</div>
																<div style={{fontSize:`${ukuranP}px`}} className="text-center mb-2">
																	<div>
																		Manakah dari kedua bagian itu yang merupakan
																		daerah penyelesaian dari pertidaksamaan{" "}
																		<InlineMath math=" x + 2y ≤ 6" />?
																	</div>
																</div>
																	<div
																		className="text-center mb-2">
																		<h6>kiri = Daerah yang memuat titik (0,0)</h6>
																		<p><i>atau</i></p>
																		<h6>kanan = Daerah yang tidak memuat titik (0,0)</h6>
																	</div>
																<div className="d-flex justify-content-center">
																	<button
																		className="btn btn-success btn-sm mx-auto"
																		onClick={() => setShow7(true)}
																	>
																		Lihat
																	</button>
																</div>
																{show7 ? (
																	<>
																		<div
																			style={{
																				marginLeft: "25px",
																				marginRight: "25px",
																				textAlign: "justify",
																				textIndent: "2rem",
																			}}
																		>
																			<p style={{fontSize:`${ukuranP}px`}}>
																				Daerah penyelesaiannya adalah di bagian
																				kiri dari grafik x + 2y = 6, yaitu
																				daerah yang memuat titik (0,0). Untuk
																				menandainya, daerah penyelesaian adalah
																				daerah yang bersih tanpa arsiran,
																				sedangkan daerah yang bukan penyelesaian
																				adalah daerah yang berarsir.
																			</p>
																		</div>
																		<div className="d-flex justify-content-center mb-3">
																			<Iframe
																				scrolling="no"
																				title="Chtambhan2"
																				src="https://www.geogebra.org/material/iframe/id/j4xu4c8t/width/420/height/470/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
																				width="420px"
																				height="470px"
																				allowFullScreen
																			/>
																		</div>
																	</>
																) : null}
															</>
														) : null}
													</>
												) : null}
											</>
										) : null}
									</>
								) : null}
							</>
						) : null}
					</>
				) : null}
		
		
			</div>
		</div>
	);
};

export default Chtambahan;
